module.exports = __webpack_public_path__ + "static/img/app-logo.30e4d39e.webp";